/**
 * @module support/store
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/* tslint:disable:no-any */ // Need to support all data types
import { Injectable } from '@angular/core';
import { ApiGatewayService } from '@core/api/services/api-gateway-service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { LoggerService } from '@core/logger/services/logger.service';

// Constants
import { SHARED_BROWSE_COMPONENTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';
// import { SETTINGS, CHANNELS } from '@environment/settings';

// Interfaces
import { APIError } from '@support/api/common/error.interface';
import { EndpointConfigInterface } from '@core/interfaces/endpoint-configuration.interface';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class AccessoriesService {
  constructor(
    private apiGateway: ApiGatewayService,
    private stateStoreUtilsService: StateStoreUtilsService,
    private logger: LoggerService
  ) {}

  public getAccessories(offerId: string, url: EndpointConfigInterface): Observable<Object> {
    const headers = new HttpHeaders();
    const pathParams = { productId: offerId };
    // let retrieveStoreId: string;
    // if (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL) {
    //   retrieveStoreId = this.stateStoreUtilsService.getStoreId();
    // }
    const sortCriterion = [
      {
        sortDirection: 'ascending',
        sortOptionValue: 'relevance',
      },
    ];
    const customerConfigData = this.stateStoreUtilsService.getCustomerConfigData();
    const data = {
      productTypes: ['ACCESSORIES'],
      productSubTypes: [''],
      billingType: this.stateStoreUtilsService.getCustomerBillingType(),
      customerId: this.stateStoreUtilsService.getCustomerId,
      accountId: this.stateStoreUtilsService.getAccountId,
      lineOfServiceId: '',
      customerSegments: [''],
      accountSegments: [''],
      dealerCodes: [''],
      masterDealerCodes: [''],
      transactionTypes: ['ACTIVATION'],
      postalCode: customerConfigData ? customerConfigData.zip : '',
      // storeId: retrieveStoreId ? retrieveStoreId : '',
      storeId: '',
      offerTypes: ['HARDGOODS'],
      offerSubTypes: ['BASE'],
      sortOptions: sortCriterion,
      pageSize: '20',
      pageNumber: '',
      creditLevels: [''],
      tacCodes: [''],
      relationTypes: [''],
      productFamilyIds: [''],
      accessoryCategory: '',
      requestedSkus: [''],
      facets: [''],
      channelSegment: {
        salesChannelCode: '',
        salesSubChannelCode: '',
        subChannelCategory: '',
      },
      context: '',
      isDetailRequest: true,
      filtersRequested: ['all'],
      filterOptionsSelected: [
        {
          fieldName: 'all',
          values: ['all'],
        },
      ],
    };

    return this.apiGateway.postRequest(url, data, headers, null, pathParams).pipe(
      map((response: HttpResponse<Object>) => {
        this.logger.debug(
          SHARED_BROWSE_COMPONENTS.SHARED_BROWSE_MODULE,
          SHARED_BROWSE_COMPONENTS.ACCESORIES_CAROUSEL_SERVICE,
          'gets accessories details ' +
            SHARED_BROWSE_COMPONENTS.ACCESORIES_CAROUSEL_SERVICE +
            ' in getAccessories() for AccessoriesService. Response: ' +
            JSON.stringify(response)
        );
        return response.body;
      }),
      catchError((err: APIError) => {
        this.logger.error(
          SHARED_BROWSE_COMPONENTS.SHARED_BROWSE_MODULE,
          SHARED_BROWSE_COMPONENTS.ACCESORIES_CAROUSEL_SERVICE,
          'gets accessories details in ' +
            SHARED_BROWSE_COMPONENTS.ACCESORIES_CAROUSEL_SERVICE +
            ' failed with error: ' +
            JSON.stringify(err)
        );
        return observableThrowError(err);
      })
    );
  }
}
